import React from 'react';
import { Flex, Tooltip } from '@chakra-ui/react';
import {
  DownloadSimple,
  FilePlus,
  GitBranch,
  HourglassMedium,
  Icon,
  Robot,
  UploadSimple,
} from 'phosphor-react';
import { FLUXO_META, FluxoMarker } from '../legalizacaoPlaybook';

// Ícone de cada marcador de fluxo (espelha o mockup: file-plus / hourglass / robot / git-branch;
// download/upload = pontos de RPA read/write da Fase 2).
const FLUXO_ICON: Record<FluxoMarker, Icon> = {
  doc: FilePlus,
  wait: HourglassMedium,
  auto: Robot,
  cond: GitBranch,
  rpa_read: DownloadSimple,
  rpa_write: UploadSimple,
};

interface FluxoIconsProps {
  markers: FluxoMarker[];
  size?: number;
  gap?: number;
}

/**
 * Linha de ícones de fluxo da etapa (com tooltip explicativo por ícone). Reusado no
 * header da coluna do board e no sub-header do drawer. A legenda completa (ícone +
 * rótulo) fica na `LegalizacaoLegenda`.
 */
export const FluxoIcons: React.FC<FluxoIconsProps> = ({ markers, size = 13, gap = 1 }) => {
  if (!markers.length) return null;
  return (
    <Flex align="center" gap={gap}>
      {markers.map(m => {
        const IconComp = FLUXO_ICON[m];
        const meta = FLUXO_META[m];
        return (
          <Tooltip key={m} label={`${meta.label} — ${meta.descricao}`} hasArrow fontSize="11px">
            <Flex align="center" cursor="default">
              <IconComp size={size} color={meta.cor} weight="regular" />
            </Flex>
          </Tooltip>
        );
      })}
    </Flex>
  );
};

export { FLUXO_ICON };
export default FluxoIcons;
